export default __webpack_public_path__ + "static/media/case2-1 (6).34f16c37.png";